import React from 'react'

export default function Wolkswagen({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 187.09 187.09"
    >
      <path
        d="M93.54 0C41.88 0 0 41.88 0 93.54c0 51.66 41.88 93.54 93.54 93.54 51.66 0 93.54-41.88 93.54-93.54C187.09 41.88 145.2 0 93.54 0zm0 178.7c-47.03 0-85.16-38.12-85.16-85.16 0-47.03 38.12-85.16 85.16-85.16 47.03 0 85.16 38.13 85.16 85.16 0 47.03-38.13 85.16-85.16 85.16z"
        fill="currentColor"
      />
      <path
        d="M74.9 29.92a66.28 66.28 0 0118.64-2.66c6.46 0 12.71.93 18.62 2.65L93.54 71.2 74.9 29.92z"
        fill="currentColor"
      />
      <path
        d="M129.12 37.61a66.582 66.582 0 0117.96 16.85l-30.57 67.64-11.79-26.23H82.37L70.58 122.1 40.05 54.4a66.616 66.616 0 0117.91-16.79l24.41 54.15h22.42l24.33-54.15zM29.5 76.39a66.428 66.428 0 00-2.24 17.15c0 25.97 14.94 48.46 36.69 59.33L29.5 76.39z"
        fill="currentColor"
      />
      <path
        d="M75.21 157.26a66.389 66.389 0 0018.34 2.57c6.35 0 12.5-.89 18.31-2.56L93.55 116.6l-18.34 40.66zM123.13 152.87c21.76-10.87 36.69-33.35 36.69-59.33 0-5.88-.76-11.58-2.2-17.01l-34.49 76.34z"
        fill="currentColor"
      />
    </svg>
  )
}
